import PropTypes from "prop-types";
import { Row, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import API from "../services/api-request";
import dayjs from "dayjs";

const SelectProductByClient = ({
  value,
  onChange,
  client_id,
  setProductData,
}) => {
  const [listData, setListData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [retryCount, setRetryCount] = useState(0);

  const getProduct = async () => {
    setListData([]);

    setLoading(true);

    try {
      const res = await API.Get(
        `transaction/outbound/list-product${
          client_id ? "?client_id=" + client_id : ""
        }`,
      );
      const newData = res?.data || [];

      if (newData.length > 0) {
        setProductData?.(newData);
        setListData((prevData) => {
          const existingIds = new Set(prevData.map((item) => item.id));
          const uniqueData = newData.filter(
            (item) => !existingIds.has(item.id),
          );
          return [...prevData, ...uniqueData];
        });
      } else {
        setListData([]);
      }
    } catch (err) {
      // Coba ulang fetch data sebanyak maksimal 10x
      if (retryCount <= 10) {
        getProduct();
        setRetryCount(retryCount + 1);
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setListData([]);
    if (client_id) {
      getProduct();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client_id]);

  return (
    <Select
      style={{ width: "100%" }}
      allowClear
      showSearch
      value={value || null}
      optionFilterProp="label"
      placeholder="Jenis Produk - Spesifikasi - Tanggal Masuk"
      onChange={onChange}
      notFoundContent={
        loading ? (
          <Row justify={"center"}>
            <Spin size="small" className="center" />
          </Row>
        ) : (
          "No Data"
        )
      }
      options={listData?.map((e) => ({
        label: `${e.name} - ${e.specification ?? "-"} - ${dayjs(
          e.schedule_at,
        ).format("DD-MM-YYYY")}`,
        value: e.id,
        area_id: Number.parseInt(e.area_id, 10),
        area: e.area_name,
        level: e.level,
        warehouse_name: e.warehouse_name,
        pallet_id: Number.parseInt(e.pallet_id, 10),
        product_id: Number.parseInt(e.product_id, 10),
        name: e.name,
        weight: e.weight,
        specification: e.specification,
        schedule_at: e.schedule_at,
        quantity: e.quantity,
      }))}
    />
  );
};


SelectProductByClient.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  client_id: PropTypes.any,
  setProductData: PropTypes.any,
};

export default SelectProductByClient;
